import {
  pixAutomaticService,
  type PixAutomaticAccountResponse,
  type PixParticipant,
} from '@/services';
import { useQuery } from '@tanstack/react-query';

/** Bancos do PIX para o autocomplete — a lista muda pouco, então cacheia. */
export function usePixParticipants(search: string, enabled = true) {
  return useQuery<PixParticipant[], Error>({
    queryKey: ['pix-participants', search],
    queryFn: async () => {
      const response = await pixAutomaticService.searchParticipants(search);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao consultar os bancos do PIX');
      }
      return response.data;
    },
    enabled,
    staleTime: 30 * 60 * 1000,
  });
}

/**
 * Conta do PIX Automático já gravada na proposta, para preencher o step ao
 * reabrir. `null` quando ainda não há conta.
 */
export function usePixAutomaticAccount(
  policyId: string | undefined,
  enabled = true
) {
  return useQuery<PixAutomaticAccountResponse | null, Error>({
    queryKey: ['pix-automatic-account', policyId],
    queryFn: async () => {
      if (!policyId) return null;
      const response = await pixAutomaticService.getAccount(policyId);
      if (!response.success) {
        throw new Error(
          response.error || 'Erro ao carregar a conta do PIX Automático'
        );
      }
      return response.data ?? null;
    },
    enabled: !!policyId && enabled,
    staleTime: 60 * 1000,
  });
}
